import { MDText } from 'i18n-react';

import { Badge } from '@motorway/mw-highway-code';

import LocalTexts from '../../EarlyDocuments.texts';

const LocalT = new MDText(LocalTexts);

export const SectionBadge = () => <Badge text={LocalT.translate('badge')} />;
